import { SlaPolicy, SlaDetailed } from '../types/SlaPoliciesTypes';
import useHttp from '../helpers/HttpMethods';
import { TaskTemplateInputModel, TaskTemplateItem, TaskTemplatePaginated } from 'types/TaskTemplateTypes';

class TaskTemplateService {
  /**
   * List task templates with filters.
   * @param {string} filter - filter in string format.
   * @returns {Promise<Response | TaskTemplatePaginated>}
   */
  static async list(filter: string): Promise<Response | TaskTemplatePaginated> {
    return await useHttp().get(`/task-templates?${filter}`);
  }

  /**
   * Searches a task template by ID.
   * @param {number} id - task template ID.
   * @returns {Promise<Response | TaskTemplateItem>}
   */
  static async findById(id: number): Promise<Response | TaskTemplateItem> {
    return await useHttp().get(`/task-templates/${id}`);
  }

  /**
   * Create a task template.
   * @param {TaskTemplateInputModel} body - .
   * @returns {Promise<Response | TaskTemplateItem>}
   */
  static async create(body: TaskTemplateInputModel): Promise<Response | TaskTemplateItem> {
    return await useHttp().post(body, '/task-templates');
  }

  /**
   * Edits a task template.
   * @param {TaskTemplateInputModel} body - task template input model.
   * @param {number} id - Task Template ID.
   * @returns {Promise<Response | TaskTemplateItem>}
   */
  static async edit(id: number, body: TaskTemplateInputModel): Promise<Response | TaskTemplateItem> {
    return await useHttp().put(body, `/task-templates/${id}`);
  }

  /**
     * Deletes a task template by the ID.
     * @param {number} id - Task template ID.
     * @returns {Promise<Response>}
     */
  static async delete(id: number): Promise<Response> {
    return await useHttp().del(`/task-templates/${id}`);
  }

}

export default TaskTemplateService;